document.addEventListener('DOMContentLoaded', function() {
    function initColorSwatches(){
        // swiper-bundle.min.js (head, defer) can fail to load (network, blockers).
        // Without this guard the ReferenceError aborts the rest of this handler.
        if (typeof Swiper === 'undefined') return;

        const colorWrappers = document.querySelectorAll('[data-custom-color-swatches]');       
        colorWrappers?.forEach(wrapper => {
           new Swiper(wrapper, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
                nextEl: wrapper.querySelector('.product-card__colors-btn__next'),
                prevEl: wrapper.querySelector('.product-card__colors-btn__prev'),
            },
           })
            
        //     function checkScroll() {
        //         const isAtEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
        //         wrapper.classList.toggle('hide-arrow', isAtEnd);
        //     }

        //     wrapper.addEventListener('click', function(e) {
        //         const rect = wrapper.getBoundingClientRect();
        //         const clickX = e.clientX - rect.left;
                
        //         if (clickX > rect.width - 24) {
        //             list.scrollBy({
        //                 left: 64,
        //                 behavior: 'smooth'
        //             });
        //         }
        //     });

        //     list.addEventListener('scroll', checkScroll);
        //     window.addEventListener('load', checkScroll);
        //     window.addEventListener('resize', checkScroll);
            
        //     checkScroll();
        });
    }


    initColorSwatches();
    window.initColorSwatches = initColorSwatches;

    function initColorSwatchesPdp(){
        if (typeof Swiper === 'undefined') return;
        const colorWrappersPdp = document.querySelectorAll('[data-custom-color-swatches-pdp]');
        colorWrappersPdp?.forEach(wrapper => {
           new Swiper(wrapper, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
                nextEl: wrapper.querySelector('.product-info__variations-btn--next'),
                prevEl: wrapper.querySelector('.product-info__variations-btn--prev'),
            },
           })
        });
    }

    initColorSwatchesPdp();
    window.initColorSwatchesPdp = initColorSwatchesPdp;


    function initBlogScroll(){
        
        const bannerSwatches = document.querySelectorAll('[data-banner-swatches]');       
        bannerSwatches?.forEach(wrapper => {
            const list = wrapper.querySelector('.blog-filter-list');
            
            function checkScroll() {
                const isAtEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
                wrapper.classList.toggle('hide-arrow', isAtEnd);
            }

            wrapper.addEventListener('click', function(e) {
                const rect = wrapper.getBoundingClientRect();
                const clickX = e.clientX - rect.left;
                
                if (clickX > rect.width - 24) {
                    list.scrollBy({
                        left: 64,
                        behavior: 'smooth'
                    });
                }
            });

            list.addEventListener('scroll', checkScroll);
            window.addEventListener('load', checkScroll);
            window.addEventListener('resize', checkScroll);
            
            checkScroll();
        });
    }


    initBlogScroll();

    function initMenuPromotionSlider() {
        const sliders = document.querySelectorAll('.menu-promotion-products-slider');
        sliders.forEach(slider => {
            if (slider && typeof Swiper !== 'undefined') {
                new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    loop: true,
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        nextEl: slider.querySelector('.menu-promotion-products-slider-button-next'),
                        prevEl: slider.querySelector('.menu-promotion-products-slider-button-prev'),
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 1,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 1,
                            spaceBetween: 40,
                        },
                    }
                });
            }
        });
    }

    initMenuPromotionSlider();

    // Add to global scope for re-initialization if needed
    window.initSwiper = function (root) {
        initMenuPromotionSlider();
        if (typeof window.initQuickBuyGallery === 'function') {
            window.initQuickBuyGallery(root || document);
        }
        if (typeof window.initPdpColorSwiper === 'function') {
            window.initPdpColorSwiper(root || document);
        }
    };

    fetch(`https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=61e1b8b8b79f07a2e86a8d44&locale=${window.Shopify.locale}-${window.Shopify.country}`)
    .then(response => response.json())
    .then(response => {
        document.querySelectorAll('.trustCount').forEach(el => el.innerHTML = response.businessUnit.numberOfReviews.total);
        let trustScore = response.businessUnit.trustScore;
        if (window.Shopify.locale !== 'en') {
            trustScore = String(trustScore).replace('.', ',');
        }
        document.querySelectorAll('.trustStar').forEach(el => el.innerHTML = trustScore);

    })
    // Tracking prevention (Edge "Strict") and ad blockers block widget.trustpilot.com.
    // The review count and score then keep whatever the Liquid rendered; without this
    // catch the rejection surfaced as an uncaught "Failed to fetch" error.
    .catch(() => {});


    // Initialize Gorgias chat and hide default button
    function initGorgiasChat() {
        var initGorgiasChatPromise = (window.GorgiasChat) 
            ? window.GorgiasChat.init() 
            : new Promise(function (resolve) { 
                window.addEventListener('gorgias-widget-loaded', function () { resolve(); });
            });

        initGorgiasChatPromise.then(function () { 
            disableGorgiasChatCampaigns();

            // Hide the default Gorgias chat button since we use custom buttons
            var timer = setInterval(function () { 
                var gorgiasContainer = document.querySelector('#gorgias-chat-container');
                if (!gorgiasContainer) {
                    return;
                }

                var chatButtonIframe = gorgiasContainer.querySelector('#chat-button');
                if (!chatButtonIframe || !chatButtonIframe.contentWindow || !chatButtonIframe.contentWindow.document) {
                    return;
                }

                var chatButtonDoc = chatButtonIframe.contentWindow.document;
                if (!chatButtonDoc.body || !chatButtonDoc.body.querySelector('#gorgias-chat-messenger-button')) {
                    return;
                }

                clearInterval(timer);

                // The default Gorgias launcher is hidden in CSS, not here.
                // Gorgias restores it after the chat window is closed, which
                // undid the inline hide that used to sit at this spot.

                // Setup toggle functionality for custom buttons
                setupGorgiasToggleButtons();
                
                // Setup custom close button
                setupGorgiasCloseButton();
            }, 50);
        });
    }

    // Setup custom close button for Gorgias chat
    function setupGorgiasCloseButton() {
        var closeButton = document.getElementById('gorgias-custom-close-btn');
        if (!closeButton) {
            console.log('Gorgias close button not found in DOM');
            return;
        }
        
        console.log('Gorgias close button found, setting up...');

        // Initially hide the close button
        closeButton.style.display = 'none';

        // Wait for GorgiasChat to be available
        var initCloseButton = function() {
            if (!isGorgiasAvailable()) {
                closeButton.style.display = 'none';
                return;
            }

            if (window.GorgiasChat && window.GorgiasChat.on) {
                console.log('GorgiasChat API available, setting up event listeners');
                // Show close button when chat opens
                window.GorgiasChat.on('widget:opened', function() {
                    console.log('Chat opened, showing close button');
                    markGorgiasChatUsed();
                    closeButton.setAttribute('data-gorgias', 'close');
                    closeButton.style.display = 'flex';
                });

                // Hide close button when chat closes
                window.GorgiasChat.on('widget:closed', function() {
                    console.log('Chat closed, hiding close button');
                    closeButton.setAttribute('data-gorgias', 'close');
                    closeButton.style.display = 'none';
                });
            } else {
                console.log('GorgiasChat API not yet available, using fallback method');
                // Fallback: monitor chat window visibility if events aren't available
                var checkChatState = setInterval(function() {
                    if (window.GorgiasChat && window.GorgiasChat.on) {
                        clearInterval(checkChatState);
                        // Events are now available, use them
                        window.GorgiasChat.on('widget:opened', function() {
                            markGorgiasChatUsed();
                            closeButton.style.display = 'flex';
                        });
                        window.GorgiasChat.on('widget:closed', function() {
                            closeButton.style.display = 'none';
                        });
                        return;
                    }

                    // Check if chat window is visible
                    var chatWindow = document.querySelector('#gorgias-chat-container #chat-window');
                    if (chatWindow) {
                        var computedStyle = window.getComputedStyle(chatWindow);
                        var isVisible = computedStyle.display !== 'none' && 
                                       computedStyle.visibility !== 'hidden' && 
                                       computedStyle.opacity !== '0';
                        closeButton.style.display = isVisible ? 'flex' : 'none';
                    } else {
                        closeButton.style.display = 'none';
                    }
                }, 100);

                // Stop checking after 10 seconds
                setTimeout(function() {
                    clearInterval(checkChatState);
                }, 10000);
            }
        };

        // Try to initialize immediately
        initCloseButton();

        // Also try after a delay in case GorgiasChat loads later
        setTimeout(initCloseButton, 1000);

        // Close chat when button is clicked (using data-attribute)
        closeButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (isGorgiasAvailable() && window.GorgiasChat.close) {
                window.GorgiasChat.close();
            }
        });
    }

    // Whether a Gorgias agent is actually available right now.
    //
    // GorgiasChat.isChatOnline() cannot be used for this: it reports whether a
    // chat can be started at all (chat enabled plus business hours) and stays
    // true while nobody is logged in. Gorgias keeps the real presence flag in
    // its own widget configuration instead.
    //
    // This is not a documented API, so a missing or non-boolean field falls
    // back to showing the button. Better a button that leads to the offline
    // form than a chat nobody can find.
    function hasAvailableGorgiasAgents() {
        var config = window.gorgiasChatConfiguration
            && window.gorgiasChatConfiguration.application
            && window.gorgiasChatConfiguration.application.config;

        if (!config || typeof config.hasActiveAndAvailableAgents !== 'boolean') {
            return true;
        }

        return config.hasActiveAndAvailableAgents;
    }

    // Gorgias chat campaigns push a proactive bubble at the visitor on every
    // page. The shop offers chat on the contact page only, so they are turned
    // off here. The iframes they mount are also hidden in CSS, because this
    // call cannot win a race against a campaign that fires before custom.js
    // has run.
    function disableGorgiasChatCampaigns() {
        if (window.GorgiasChat && window.GorgiasChat.disableChatCampaigns) {
            try {
                window.GorgiasChat.disableChatCampaigns();
            } catch (error) {
                // Never let this break the rest of the chat setup.
            }
        }
    }

    // Once a visitor has opened the chat, Gorgias' own launcher is allowed back
    // so they can return to their conversation from any page. The flag is read
    // again in the head of theme.liquid, before paint, so the launcher does not
    // flash in and out on the next page load.
    function markGorgiasChatUsed() {
        document.documentElement.classList.add('gorgias-chat-used');

        try {
            window.localStorage.setItem('cp-gorgias-chat-used', '1');
        } catch (error) {
            // Private mode or blocked storage: the launcher simply stays hidden
            // on the next page load.
        }
    }

    // Check if Gorgias is available and initialized
    function isGorgiasAvailable() {
        return typeof window.GorgiasChat !== 'undefined' && 
               window.GorgiasChat && 
               (window.GorgiasChat.open || window.GorgiasChat.init);
    }

    // Show/hide buttons based on Gorgias availability
    function toggleGorgiasButtonsVisibility(show) {
        var buttons = document.querySelectorAll('[data-gorgias="open"]');
        
        buttons.forEach(function(button) {
            if (show) {
                // Show button - use appropriate display based on button type
                if (button.classList.contains('header__wrapper-gorgias-btn-mob')) {
                    // Mobile button - check if it should be visible on mobile
                    button.style.display = '';
                } else {
                    // Desktop button
                    button.style.display = '';
                }
            } else {
                // Hide button
                button.style.display = 'none';
            }
        });
    }

    // Setup toggle functionality for Gorgias chat buttons
    function setupGorgiasToggleButtons() {
        // Function to check if chat is currently open
        function isChatOpen() {
            var chatWindow = document.querySelector('#gorgias-chat-container #chat-window');
            if (!chatWindow) {
                return false;
            }
            // Check multiple ways to determine if chat is open
            var computedStyle = window.getComputedStyle(chatWindow);
            var isVisible = computedStyle.display !== 'none' && 
                           computedStyle.visibility !== 'hidden' && 
                           computedStyle.opacity !== '0';
            return isVisible;
        }

        // Function to toggle chat
        function toggleGorgiasChat() {
            if (!isGorgiasAvailable()) {
                return;
            }

            var currentlyOpen = isChatOpen();

            if (currentlyOpen) {
                // Chat is open, close it
                if (window.GorgiasChat.close) {
                    window.GorgiasChat.close();
                }
            } else {
                // Chat is closed, open it
                if (window.GorgiasChat.open) {
                    markGorgiasChatUsed();
                    window.GorgiasChat.open();
                }
            }
        }

        // Setup buttons with data-attributes
        var buttons = document.querySelectorAll('[data-gorgias="open"]');
        buttons.forEach(function(button) {
            // Remove existing onclick
            button.onclick = null;
            
            button.addEventListener('click', function(e) {
                e.preventDefault();
                toggleGorgiasChat();
            });
        });

        // Show the buttons only when the widget has loaded AND an agent is
        // actually available. Without the second check the button stays up
        // while nobody is there, because Gorgias keeps serving the widget and
        // falls back to its offline form.
        var shouldShowButtons = function() {
            return isGorgiasAvailable() && hasAvailableGorgiasAgents();
        };

        var checkAvailability = function() {
            toggleGorgiasButtonsVisibility(shouldShowButtons());
        };

        // Check immediately
        checkAvailability();

        // Check periodically until Gorgias is available
        var availabilityCheck = setInterval(function() {
            if (isGorgiasAvailable()) {
                checkAvailability();
                clearInterval(availabilityCheck);
            }
        }, 500);

        // Stop checking after 10 seconds
        setTimeout(function() {
            clearInterval(availabilityCheck);
            checkAvailability(); // Final check
        }, 10000);
    }

    // Initialize Gorgias chat
    initGorgiasChat();
    
    // Also setup close button immediately (will wait for GorgiasChat if needed)
    setupGorgiasCloseButton();
    
});

/**
 * Cook & Pan - Custom Product Card Logic
 * Bevat: Kleur-swatches, prijs/titel/badge-updates, anti-flicker & navigatie.
 */

document.addEventListener('DOMContentLoaded', () => {

  // --- 1. Helpers ---
  const updateTitleInstantSmooth = (titleElement, newText) => {
    if (!titleElement || !newText || titleElement.textContent.trim() === newText) return;
    titleElement.style.transition = 'none';
    titleElement.style.opacity = '0';
    titleElement.textContent = newText;
    requestAnimationFrame(() => {
      titleElement.style.transition = 'opacity 0.15s ease-in';
      titleElement.style.opacity = '1';
    });
  };

  const updateElementContent = (card, selector, newHtml, isDiscount = false) => {
    const container = card.querySelector(selector);
    if (!container) return;
    const cleanHtml = newHtml ? newHtml.trim() : "";
    if (cleanHtml !== "") {
      container.innerHTML = cleanHtml;
      container.style.display = ''; 
      container.style.opacity = '1';
    } else {
      container.innerHTML = '';
      if (isDiscount) container.style.display = 'none';
    }
  };

  // --- 2. Hoofdfunctie ---
  const handleSwatchAction = (swatch, isClick) => {
    const card = swatch.closest('product-card') || swatch.closest('.product-card');
    if (!card) return;

    if (document.querySelector('[data-sets-plp]')?.contains(swatch)) return;

    // Op desktop: negeer hover als er al geklikt is.
    if (!isClick && card.hasAttribute('data-swatch-clicked')) return;

    const mainImage = card.querySelector('.js-main-product-image');
    const imageLink = card.querySelector('.js-product-card-image-link');
    const titleElement = card.querySelector('.product-card__title');
    const quickBuy = card.querySelector('.product-card__quick-buy'); 
    
    const hoverImageUrl = swatch.getAttribute('data-hover-image');
    const hoverSecondImageUrl = swatch.getAttribute('data-hover-second-image');
    const secondImage = card.querySelector('.product-card__image--secondary');
    const targetUrl = swatch.getAttribute('href');
    const priceHtml = swatch.getAttribute('data-price-html');
    const newTitle = swatch.getAttribute('data-title');
    const badgesHtml = swatch.getAttribute('data-badges-html');
    const isPreorder = swatch.getAttribute('data-is-preorder') === 'true';

    if (isClick) {
      card.setAttribute('data-swatch-clicked', 'true');
      const siblings = card.querySelectorAll('.product-card__colors-link');
      siblings.forEach(s => s.classList.remove('js-color-active'));
      swatch.classList.add('js-color-active');
      
      if (imageLink && targetUrl) {
          imageLink.setAttribute('href', targetUrl);
          imageLink.setAttribute('data-force-url', targetUrl);
      }
    } else {
      const siblings = card.querySelectorAll('.product-card__colors-link');
      siblings.forEach(s => s.classList.remove('js-color-hover'));
      swatch.classList.add('js-color-hover');
    }

    if (mainImage && hoverImageUrl) {
      mainImage.setAttribute('src', hoverImageUrl);
      mainImage.removeAttribute('srcset'); 
      const priceContainer = card.querySelector('price-list');
      if (priceContainer && priceHtml) priceContainer.outerHTML = priceHtml; 
    }

    if (secondImage && hoverSecondImageUrl) {
      secondImage.setAttribute('src', hoverSecondImageUrl);
      secondImage.removeAttribute('srcset'); 
    }

    
    // Skip title swap when card opts out (e.g. sets-collection template
    // shows a group-level title that should stay stable while hovering
    // individual color swatches).
    if (!card.hasAttribute('data-lock-title')) {
      updateTitleInstantSmooth(titleElement, newTitle);
    }
    updateElementContent(card, '.product-card__badge-list-wrapper', badgesHtml);
    // updateElementContent(card, '.product-card-discount-badge', discountHtml, true);
    if (quickBuy) quickBuy.style.display = isPreorder ? 'none' : '';

    if (typeof window.syncQuickBuyDrawerFromSwatch === 'function') {
      window.syncQuickBuyDrawerFromSwatch(card, swatch);
    }
  };

  // --- 3. Event Listeners ---

  // HOVER: Alleen uitvoeren als het GEEN touch-event is
  document.addEventListener('mouseover', (e) => {
    if (window.matchMedia("(pointer: coarse)").matches) return; // Stop op mobiel/touch
    // Synthetic events (bots, in-app browsers) can target document or a text node, which have no closest().
    if (!(e.target instanceof Element)) return;

    const swatch = e.target.closest('.product-card__colors-link');
    if (swatch) handleSwatchAction(swatch, false);
    
    const wrapper = e.target.closest('.product-card__colors-wrapper');
    if (wrapper) {
      const card = wrapper.closest('product-card') || wrapper.closest('.product-card');
      if (card) card.classList.add('is-hovering-swatches');
    }
  });

  // MOUSEOUT: Alleen uitvoeren als het GEEN touch-event is
  document.addEventListener('mouseout', (e) => {
    if (window.matchMedia("(pointer: coarse)").matches) return; // Stop op mobiel/touch
    if (!(e.target instanceof Element)) return;

    const wrapper = e.target.closest('.product-card__colors-wrapper');
    if (wrapper && !wrapper.contains(e.relatedTarget)) {
      const card = wrapper.closest('product-card') || wrapper.closest('.product-card');
      if (card && !card.hasAttribute('data-swatch-clicked')) {
          card.classList.remove('is-hovering-swatches');
          const siblings = card.querySelectorAll('.product-card__colors-link');
          siblings.forEach(s => s.classList.remove('js-color-hover'));

          const activeSwatch = card.querySelector('.product-card__colors-link--active');
          if (activeSwatch) {
            handleSwatchAction(activeSwatch, false); // Herstel naar origineel
          }
      }
    }
  });

  // KLIK NAVIGATIE FIX (iOS focus)
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    const imageLink = e.target.closest('.js-product-card-image-link');
    if (imageLink) {
        const card = imageLink.closest('product-card') || imageLink.closest('.product-card');
        if (card && card.hasAttribute('data-swatch-clicked')) {
            const targetUrl = imageLink.getAttribute('data-force-url') || imageLink.getAttribute('href');
            if (targetUrl) {
                e.preventDefault();
                e.stopImmediatePropagation();
                window.location.href = targetUrl;
            }
        }
    }
  }, true);

  // SWATCH KLIK
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    const swatch = e.target.closest('.product-card__colors-link');
    if (swatch) {
      e.preventDefault(); 
      e.stopPropagation();
      handleSwatchAction(swatch, true);
    }
  });

});

(function () {
  function closeFaqItem(details) {
    if (!details || !details.hasAttribute('open')) return;

    var content = details.querySelector('.et-dropdown-content');
    if (!content) {
      details.removeAttribute('open');
      return;
    }

    content.style.height = content.scrollHeight + 'px';
    void content.offsetHeight;
    content.style.height = '0px';

    setTimeout(function () {
      details.removeAttribute('open');
      content.style.height = '';
    }, 200);
  }

  function openFaqItem(details) {
    if (!details || details.hasAttribute('open')) return;

    var content = details.querySelector('.et-dropdown-content');
    details.setAttribute('open', '');
    if (!content) return;

    content.style.height = '0px';
    void content.offsetHeight;
    content.style.height = content.scrollHeight + 'px';

    setTimeout(function () {
      content.style.height = 'auto';
    }, 200);
  }

  function openLightLabs(event) {
    if (event && event.preventDefault) event.preventDefault();

    // Prefer the widget block nearest the clicked trigger (works on PDPs),
    // then the landing-hero block, then any block on the page.
    var target = event && event.target && event.target.closest;
    var lightlabsSelector = '.lightlabs-block, .product-info__lightlabs';
    var block =
      (target && event.target.closest(lightlabsSelector)) ||
      (target && event.target.closest('section, .shopify-section') &&
        event.target.closest('section, .shopify-section').querySelector(lightlabsSelector)) ||
      document.querySelector('.section-test-lander-hero .lightlabs-block') ||
      document.querySelector('.product-info__lightlabs') ||
      document.querySelector('.lightlabs-block');
    var button = block && block.querySelector('lightlabs-widget .ll-content');
    if (button) {
      button.style.display = 'block';
      button.click();
      button.style.display = '';
    }
  }

  function styleLightLabsLinks(root) {
    var sourceTrigger = document.querySelector('.section-test-lander-hero [data-lightlabs-trigger]');
    var sourceLogo = sourceTrigger && sourceTrigger.querySelector('.lightlabs-block__logo');
    if (!sourceLogo) return;

    var fallbackLabel = sourceTrigger.textContent.trim();

    (root || document).querySelectorAll('a[href="#labresult"], a[href$="#labresult"]').forEach(function (link) {
      if (link.classList.contains('lightlabs-block__link')) return;

      var logo = sourceLogo.cloneNode(true);
      var label = document.createElement('span');
      label.textContent = link.textContent.trim() || fallbackLabel;

      link.classList.add('lightlabs-block__link');
      link.replaceChildren(logo, label);
    });
  }

  window.openLightLabs = openLightLabs;
  styleLightLabsLinks(document);

  document.addEventListener('shopify:section:load', function (event) {
    styleLightLabsLinks(event.target);
  });

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.et-faq-section .et-dropdown-summary');
    if (summary) {
      event.preventDefault();

      var details = summary.closest('details');
      var list = details && details.closest('.et-faq-list');
      var isOpen = details && details.hasAttribute('open');

      if (list && !isOpen) {
        list.querySelectorAll('details[open]').forEach(function (sibling) {
          if (sibling !== details) closeFaqItem(sibling);
        });
      }

      if (isOpen) {
        closeFaqItem(details);
      } else {
        openFaqItem(details);
      }
      return;
    }

    var trigger = event.target.closest && event.target.closest(
      '[data-lightlabs-trigger], a[href="#labresult"], a[href$="#labresult"], .product-info__lightlabs-button'
    );
    if (trigger) openLightLabs(event);
  });
})();
